module.exports = __webpack_public_path__ + "img/bracken.cb4b81d8.jpg";